/*
 * Settings that live with their feature (2026-10-29, owner: settings native to their own section, like Proposal
 * settings). Each feature page has a settings button at the top right that opens its settings page under the feature's
 * own address (/invoices/settings, /schedule/settings ...). Settings still lists them and its search still finds them.
 */
import { Link, useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { useSession } from "../../app/session";
import { Icon } from "../../components/Icon";
import { Button, Page } from "../../components/parts";
import { useScrollToCard } from "./Layout";

/** The settings button at the top right of a feature page. Hidden from people who cannot read settings. */
export function SettingsButton({ to, children }: { to: string; children: ReactNode }) {
  const { can } = useSession();
  const navigate = useNavigate();
  if (!can("settings.read")) return null;
  return (
    <Button type="tertiary" icon="settings" onClick={() => void navigate({ to })}>
      {children}
    </Button>
  );
}

/** A feature's settings page: its title, a way back to the feature, and the same cards Settings used to show. */
export function FeatureSettings({
  title,
  back,
  backLabel,
  children,
}: {
  title: string;
  back: string;
  backLabel: string;
  children: ReactNode;
}) {
  useScrollToCard();
  return (
    <Page
      title={title}
      subtitle={
        <Link to={back} className="back-link">
          <Icon name="chevronLeft" size={16} /> {backLabel}
        </Link>
      }
      secondaryAction={
        <Link to="/settings" className="btn tertiary small">
          All settings
        </Link>
      }
    >
      <div className="stack settings-main feature-settings">{children}</div>
    </Page>
  );
}
